/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetSummaryResponse {
    getFixupPrototypeFunction() { return BudgetSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetSummaryResponse>): BudgetSummaryResponse {
        let obj = Object.assign(new BudgetSummaryResponse(), model);
        BudgetSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetSummaryResponse>): BudgetSummaryResponse {
        if (!model) return null;
        return BudgetSummaryResponse.newInstance(<BudgetSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetSummaryResponse) {
        if (!obj) return;

        models.BudgetSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetSummaryResponse): boolean {
        Object.setPrototypeOf(obj, BudgetSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_budgets_count === undefined) {
            this.total_budgets_count = 0;
        }
    }

    /**
     * budget count
     */
    total_budgets_count: number;

}
